// extracted by mini-css-extract-plugin
export default {"Dialog":"Dialog_Dialog__-iTQj","Dialog__content":"Dialog_Dialog__content__09A-V","Dialog--close":"Dialog_Dialog--close__tg1Z3"};